import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { Skeleton } from "@/components/ui/skeleton";
import { nb } from "@/lib/format";
import { COLORS } from "./constants";

export function OwnershipChart({ cap }) {
  const rows = cap?.rows || [];
  const pieData = rows.map((r) => ({ name: r.name, value: r.shares, pct: r.ownership_pct }));

  return (
    <div className="rounded-xl border border-border/60 bg-card p-6 shadow-sm lg:col-span-2">
      <h3 className="font-headings text-sm font-bold uppercase tracking-wider text-muted-foreground">Eierfordeling</h3>
      {cap ? (
        <div className="relative mt-2 h-56">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={pieData} dataKey="value" nameKey="name" innerRadius={62} outerRadius={90} paddingAngle={2} stroke="none">
                {pieData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip
                formatter={(v, n, p) => [`${nb(v)} aksjer (${p.payload.pct}%)`, n]}
                contentStyle={{ borderRadius: 12, border: "1px solid hsl(var(--border))", background: "hsl(var(--popover))", color: "hsl(var(--popover-foreground))", fontSize: 12 }}
              />
            </PieChart>
          </ResponsiveContainer>
          <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
            <p className="font-headings text-2xl font-extrabold">{nb(cap.total_shares)}</p>
            <p className="text-xs text-muted-foreground">aksjer totalt</p>
          </div>
        </div>
      ) : (
        <Skeleton className="mt-4 h-56 rounded-lg" />
      )}
      <div className="mt-4 space-y-2">
        {rows.map((r, i) => (
          <div key={r.id} className="flex items-center gap-2 text-sm">
            <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: COLORS[i % COLORS.length] }} />
            <span className="min-w-0 flex-1 truncate">{r.name}</span>
            <span className="font-medium">{r.ownership_pct}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}
